import React, { useEffect, useRef, useState } from 'react'
import OutgoingPayment from './OutgoingPayment'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import _, { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import { isAxiosError } from 'axios'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { formatNumberWithIntl } from '../../lib/FormatNumbersWithIntl'

const JournalEntries = () => {
	const navigation = useNavigate()
	const errorRef = useRef()
	const successRef = useRef()
	const { getMe } = useSelector((state) => state.main)

	const [isLoading, setIsLoading] = useState(false)
	const [startDate, setStartDate] = useState(
		new Date().toISOString().split('T')[0],
	)
	const [pagination, setPagination] = useState({
		page: 0,
	})
	const [cashAccountsData, setCashAccountsData] = useState([])

	const [data, setData] = useState({
		data: [],
	})
	const search = (value) => {
		setIsLoading(true)
		api
			.get(
				`/JournalEntries?$filter=U_DocNum	 eq 'Journal'${getMe?.Department2.Name === 'Sotuv' ? ` and U_Creator eq ${getMe?.EmployeeID}` : ''} and ReferenceDate ge '${startDate + ' 00:00:00.000Z'}'&$skip=${pagination.page * 20}&$orderby=ReferenceDate desc`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=20',
					},
				},
			)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				setData({
					data: [...resData],
				})
				setIsLoading(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
				setIsLoading(false)
			})
	}

	const cashAccounts = async () => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name&$filter=startswith(Code, '5') or startswith(Code, '94') or ExternalCode eq '12'`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})
		setCashAccountsData(data)
	}

	useEffect(() => {
		search()
	}, [startDate, pagination])
	useEffect(() => {
		cashAccounts()
	}, [])

	const newDatas = () => {
		if (data.data.length < 20) {
			alert('Никакой другой информации')
		} else {
			setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
		}
	}

	const oldData = () => {
		if (pagination.page > 0) {
			setPagination((prev) => ({ ...prev, page: prev.page - 1 }))
		} else {
			alert('Никакой другой информации')
		}
	}

	const handleStartDateChange = (event) => {
		setStartDate(event.target.value)
	}

	const handleCardCodeChange = _.debounce((e) => {
		search({ cardCode: e.target.value })
	}, 1000)

	const handleCardNameChange = _.debounce((e) => {
		search({ cardName: e.target.value })
	}, 1000)

	return (
		<Layout>
			<OutgoingPayment>
				<div className="container">
					<p className="productTitle">Принят деньги на кассу</p>
					<div className="flex justify-between items-end m-5">
						<div className="searchCard mt-8">
							{/* <div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Код клиента
								</p>
								<input
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									type="text"
									onChange={handleCardCodeChange}
								/>
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Имя клиента
								</p>
								<input
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									type="text"
									onChange={handleCardNameChange}
								/>
							</div> */}
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Дата начала
								</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={startDate}
									onChange={handleStartDateChange}
								/>
							</div>
						</div>
						<Button
							btnStyle={{ width: 'max-content', padding: '0 10px' }}
							onClick={() => navigation('/create-journal-entries')}
						>
							Добавить
						</Button>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Дата
											</th>
											<th scope="col" className="px-6 py-4">
												C кассы
											</th>
											<th scope="col" className="px-6 py-4">
												На сейф
											</th>
											<th scope="col" className="px-6 py-4">
												Сумма
											</th>
											<th scope="col" className="px-6 py-4">
												Валюта
											</th>

											<th scope="col" className="px-6 py-4">
												Комментарий
											</th>
										</tr>
									</thead>
									<tbody>
										{data.data.map((v, i) => {
											const accCode = get(
												v.JournalEntryLines[0],
												'AccountCode',
												'',
											)
											const accName = cashAccountsData.find(
												(item) => item.Code == accCode,
											)?.Name
											const contrAccCode = get(
												v.JournalEntryLines[0],
												'ContraAccount',
												'',
											)
											const contrAccName = cashAccountsData.find(
												(item) => item.Code == contrAccCode,
											)?.Name

											return (
												<tr
													className="bg-white border-b  hover:bg-gray-50 "
													key={i}
												>
													<td className="px-6 py-4">
														{moment(get(v, 'ReferenceDate', '')).format(
															'DD-MM-YYYY',
														)}
													</td>
													<td className="px-6 py-4 whitespace-nowrap">
														{`${contrAccCode} - ${contrAccName}`}
													</td>
													<td className="px-6 py-4">
														{`${accCode} - ${accName}`}
													</td>
													<td className="px-6 py-4">
														{get(v.JournalEntryLines[0], 'FCCurrency', '') ===
														'UZS'
															? formatNumberWithIntl(
																	get(v.JournalEntryLines[0], 'FCDebit', ''),
																)
															: formatNumberWithIntl(
																	get(v.JournalEntryLines[0], 'Debit', ''),
																)}
													</td>
													<td className="px-6 py-4">
														{get(v.JournalEntryLines[0], 'FCCurrency', '') ||
															'USD'}
													</td>

													<td className="px-6 py-4">{get(v, 'Memo', '')}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div style={{ alignItems: 'center' }} className="flex">
									<Button onClick={oldData} btnStyle={{ marginRight: 10 }}>
										{'<'}
									</Button>
									<p style={{ marginRight: '10px' }}>{pagination.page + 1}</p>
									<Button onClick={newDatas}>{'>'}</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</OutgoingPayment>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default JournalEntries
